export enum LoadingSizeType {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large'
}
